import { ApiResponse } from "apisauce";
import { IMedicalDeviceInfo, IResponseSnapshot } from '../../models';
import { Api } from "../api/api";
import {
  TGetMedicalDeviceInfoResult
} from "./MedicalDeviceInfoTypes";

  /**
  * # MedicalDeviceInfo Api 서비스
  * 
  * 서비스의 설명을 작성하세요.
  * 
  * ## 사용방법
  * 
  * ```ts
  * const service = new MedicalDeviceInfoApi();
  * 
  * ```
  */
 export class MedicalDeviceInfoApi {
  private api: Api;

  constructor(api: Api) {
    this.api = api;
    this.api.setup();
  }

  private BASE_URL = '/medicalDeviceInfo';



  async get(): Promise<TGetMedicalDeviceInfoResult> {
    try {
      const url = `${this.BASE_URL}`;
      const params = {};
      const response: ApiResponse<any> = await this.api.apisauce.get( url, params );
  

      const medicalDeviceInfo: IMedicalDeviceInfo = response.data.data;
      const responseInfo: IResponseSnapshot = response.data;

      return { kind: "ok", medicalDeviceInfo, responseInfo:responseInfo };

    } catch (e) {
      return { kind: "bad-data" };
    }
  }


}